var map = {
	"./logo_signet.svg": 2846,
	"./logo_variant_2.svg": 7882,
	"./logo_vplayer.png": 3,
	"./signet-weiss.png": 1998,
	"./signet.png": 3894,
	"./tu_error_logo.png": 508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4856;